import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";


export class TriggerJohan extends TriggerBase {

    constructor() {
        super(TriggerKind.JOHAN);
    }

    valid() {
        return super.valid();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerJohan());
        } else if (target instanceof TriggerJohan) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerJohanScope extends TriggerScope {

    static _values = [
        new TriggerJohanScope(1, "LIFETIME_GREAT"),
        new TriggerJohanScope(2, "LIFETIME_LESS")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerJohanScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerJohanScope());
        } else if (target instanceof TriggerJohanScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerJohan, {
    _scope: alias("scope", TriggerJohanScope.schema()),
});
